<template>
  <div
    class="modal fade show custom-modal"
    id="myModalconfirm"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    :class="{'modal-show':showModal}"
  >
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
          <img src="@/assets/images/done.png" class="tick" />
                    <button type="button" class="close" data-dismiss="modal" @click="handleCloseModal()">&times;</button>

          </div>
          <div class="modal-body">
            <p class="text-center">{{editPin? 'Your PIN has been successfully updated.' : 'Your PIN has been successfully generated.'}}</p>
            <p class="pin-it text-center">PIN : {{pinNo}}</p>
            <p class="text-center">PIN Status:</p>
            <p class="pin-it text-center">{{pinStatus}}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn bgc-btn-primary"
              data-dismiss="modal"
              @click="generatePin()"
            >Generate Another Pin</button>
            <button
              type="button"
              class="btn bgc-btn-primary"
              @click="gotoSearchPage()"
              data-dismiss="modal"
            >Pin Search</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchPin from "../../searchPin/SearchPin.vue";
export default {
  name: "SuccessModal",
  components: {
    SearchPin
  },
  props: ['showModal','pinNo','pinStatus','editPin'],
  setup(props, { root, parent }){
     function gotoSearchPage(){
      root.$router.push({ name: "SearchPin" });
    }
    function handleCloseModal() {
      parent.closeSuccessModal();
    }
    function generatePin(){
      parent.closeSuccessModal();
      window.location = root.$store.getters.getLobUrl('motor')+'/generatePin';
    }
    return {
      gotoSearchPage,
      generatePin,
      handleCloseModal
    }
  }
};
</script>

<style scoped>
.modal-footer {
  text-align: center;
  display: block;
}
.pin-it {
  font-weight: bold;
}
.modal-body {
  position: relative;
  padding-top: 50px;
  overflow-y: auto;
}
.btn:hover {
  color: #ffffff;
}
button.close {
  padding-top: 13px;
  text-align: right;
  padding-right: 17px;
}
.tick {
  color: white;
  position: relative;
  border: none;
  top: 30px;
  width: 45px;
  height: 45px;
  left: 46%;
}
.custom-modal{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.4);
  transform:scale(0);
}
.modal-show{
  display:block;
  transform:scaleY(0) scaleX(0);
  animation:unfoldIn 0.25s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
}
</style>
